<template>
    <div
        :id="id"
        class="transactionlink-graphic-image"
        :class="[alignment, { 'fixed-size': hasFixedSize }]"
    >
        <img
            :style="hasFixedSize ? { width: `${width}px`, height: `${height}px` } : undefined"
            :src="url"
            alt="graphic-image"
        />
    </div>
</template>

<script setup>
import { computed } from 'vue'

defineOptions({ inheritAttrs: false })

const props = defineProps({
    id: String,
    url: String,
    options: Object,
})

const height = computed(() => props.options?.height || 0)
const width = computed(() => props.options?.width || 0)
const alignment = computed(() => props.options?.alignment || '')
const hasFixedSize = computed(() => !!+width.value || !!+height.value)
</script>

<style lang="sass" scoped>
@import "./GraphicImage.sass"
</style>
